export default __webpack_public_path__ + "static/media/malware_survey_figure.a98e75c9.png";